import { useTranslation } from 'react-i18next';

import { ErrorNotice } from '../../components/ErrorNotice';
import { LoadingIndicator } from '../../components/Spinner';
import { useNotificationPreferences, useSetNotificationPreference } from './queries';

/**
 * Wovon man erfahren moechte -- F3-09, K-55.
 *
 * **Die Liste kommt vom Server.** Welche Ereignisse es gibt, steht in
 * `NOTIFICATION_EVENTS`; eine zweite Liste hier liefe auseinander, sobald
 * eines dazukommt -- und der Anwender saehe einen Schalter, den niemand
 * abfragt.
 *
 * **Alles ist eingeschaltet, solange nichts eingestellt wurde.** Der Server
 * liefert deshalb die vollstaendige Liste und nicht nur die gespeicherten
 * Zeilen: Eine Maske, die nur Gespeichertes zeigt, liesse einen neuen
 * Kollegen glauben, er bekomme nichts.
 */
export function NotificationPanel() {
  const { t } = useTranslation();
  const preferences = useNotificationPreferences();
  const set = useSetNotificationPreference();

  return (
    <section className="card">
      <h2>{t('notifications.title')}</h2>
      <p className="table__muted">{t('notifications.hint')}</p>

      {preferences.isPending ? <LoadingIndicator /> : null}
      {preferences.isError ? <ErrorNotice error={preferences.error} /> : null}
      {set.isError ? <ErrorNotice error={set.error} /> : null}

      {(preferences.data ?? []).map((preference) => (
        <label className="field__checkbox" key={preference.event}>
          <input
            type="checkbox"
            checked={preference.by_email}
            onChange={(event) => {
              set.mutate({ event: preference.event, by_email: event.target.checked });
            }}
          />
          {t(`notificationEvent.${preference.event}`, { defaultValue: preference.event })}
        </label>
      ))}
    </section>
  );
}
